import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const BASE_PATH = 'menu'

const client = new ApiClient(API_NAME)

export default {
  async get(businessId) {
    return client.get(`/business/${businessId}/${BASE_PATH}`)
  }
}
